import * as React from 'react';

import { Button, Dialog } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

interface LearnMoreDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: React.ReactNode;
}

const LearnMoreDialog: React.VFC<LearnMoreDialogProps> = ({ isOpen, onClose, title, message }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} color="darkBlue">
      <Dialog.HeadingGroup>{title}</Dialog.HeadingGroup>
      <Dialog.Content>{message}</Dialog.Content>
      <Dialog.Actions>
        <Button type="button" size="medium" variant="primary" onClick={onClose}>
          {_t('OK')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default LearnMoreDialog;
